import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// import styles
import './_subheading.scss';

const Subheading = ({ id, children, customClasses, marginBottom, marginTop, variant, handleOnClick }) => {
  const marginTopClass = (marginTop && 'et-core-subheading_margintop');
  const marginBottomClass = (marginBottom && 'et-core-subheading_marginbottom');

  const rootClass = classNames([ 'et-core-subheading', customClasses.root, marginTopClass, marginBottomClass ]);
  const subheadingClass = classNames(`et-core-subheading_${ variant }`, `${ handleOnClick && 'et-core-subheading_onHover' }`, customClasses.subheading);


  const getContent = useCallback(() => {
    switch (variant) {
    // case 'h3': return (<h3 className={subheadingClass}>{children}</h3>);
    case 'h4': return (<h4 id={id} className={subheadingClass} onClick={handleOnClick}>{children}</h4>);
    case 'p': return (<p id={id} className={subheadingClass} onClick={handleOnClick}>{children}</p>);

    default: return (<h3 id={id} className={subheadingClass} onClick={handleOnClick}>{children}</h3>);
    }
  }, [ variant, subheadingClass, children, handleOnClick, id ]);

  return (
    <div className={rootClass}>
      { getContent() }
    </div>
  );
};

Subheading.propTypes = {
  children: PropTypes.node,
  customClasses: PropTypes.object.isRequired,
  marginTop: PropTypes.bool,
  marginBottom: PropTypes.bool,
  variant: PropTypes.oneOf([ 'h3', 'h4', 'p' ])
};

Subheading.defaultProps = {
  customClasses: {},
  variant: 'h3',
  handleOnClick: () => { console.log('Default handle onClick')},
  id: ''
};

export default Subheading;